export const limitExceptionSettingsFormRules = {
  tag: { required: true, message: 'Please select tag', trigger: 'change' },
  min: { required: true, message: 'Limit value required', trigger: 'blur' },
  max: { required: true, message: 'Limit value required', trigger: 'blur' },
};
